import React, { useState, useEffect } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { INFLUX_API } from '../../config/api';

const DisplayShift = ({ machineName, bucket, startTime, endTime }) => {
  const [loading, setLoading] = useState(true);
  const [shift, setShift] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const endTimeCut = dayjs(endTime).subtract(2, 'minute').toISOString();

      const response = await axios.get(
        `${INFLUX_API}/api/influx/${machineName}/shift?start=${startTime}&end=${endTimeCut}&bucket=${bucket}`
      );

      setShift(response.data.shift);
      console.log(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Function to fetch data from the API using axios
    fetchData();
  }, [startTime, endTime]);

  return (
    <h3 className="mb-0 ms-auto">
      <span style={{ marginRight: '12px' }}>Shift : {shift}</span>
    </h3>
  );
};

export default DisplayShift;
